import * as React from "react"
import { GeneralContext } from "../../../core/general.context"
import { Property } from "../property/property.component"
import { StyledAddress } from "./address.style"
import { InputElement } from "../../input/input.component"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { useForm } from "react-hook-form"
import {
  PROJECT_COUNTRY,
  PROJECT_LANGUAGE,
  PROJECT_COUNTRIES,
  calls,
  VALID_SPANISH_ZIP_PREFIXES
} from "../../../core/APIUtils"
import { LabelContext } from "../../../core/label.context"
import { StyledInput } from "../../input/input.style"
import { EAddressType } from "../../../common/common.models"
import { CartContext } from "../../../core/cart.context"
import { inputMaxLength } from "../../../common/constants"
import { useState } from "react"
import {CheckoutContext} from "../../../core/checkout.context"
import {RESTContext} from "../../../core/rest.context";
import {useKeyDownAsClick} from "../../../hooks/useKeyDownAsClick";
import {UserContext} from "../../../core/user.context";
import { AutocompleteAddress } from "./autocomplete.address"


export const Address = (props: any) => {
  const { item, compact } = props
  const { t } = React.useContext(LabelContext)

  return (
    <>
      {item && !compact && (
        <StyledAddress className="addressItem">
          <div className="addressUser">
            <b>
              {item.firstName} {item.lastName}
            </b>
          </div>
          <Property
            label={t("ecommerce.common.address")}
            item={
              item.streetName +
              " " +
              (item.streetNumber !== undefined ? item.streetNumber : "") +
              ", " +
              item.city +
              " - " +
              item.postalCode +
              (item.region !== undefined ? " - (" + item.region + ")" : "")
            }
          />
          {item.mobile && <Property label={t("ecommerce.common.mobile")} item={item.mobile}/>}
          {item.company && <Property label={t("ecommerce.common.company")} item={item.company}/>}
        </StyledAddress>
      )}

      {item && compact && (
        <StyledAddress className="addressItem">
          <div className="addressUser">
            {item.company} {item.firstName} {item.lastName},
            {item.streetName +
              " " +
              (item.streetNumber !== undefined ? item.streetNumber : "") +
              ", " +
              item.city +
              " - " +
              item.postalCode +
              " - (" +
              item.region +
              ")"}
          </div>
        </StyledAddress>
      )}
    </>
  )
}


export const AddAddress = React.forwardRef((props: any, ref) => {
  const { type } : { type: EAddressType } = props
  const { setInvoiceValue } = React.useContext(GeneralContext)
  const { useShippingAddressAsBilling, setUseShippingAddressAsBilling, setAddAddressFormVisibility, numberAddressAvailable, isAddressEdit } = React.useContext(CheckoutContext)
  const { setSendInvoice } = React.useContext(CartContext)
  const { ajaxMiddleware$ } = React.useContext(RESTContext)
  const { t } = React.useContext(LabelContext)
  const { cookieConsent } = React.useContext(UserContext)
  const [addressData] = React.useState<any>({
    ...props.dataEdit,
  })
  const isFromMyAccount = props.isFromMyAccount ? props.isFromMyAccount : false
  const [formVisibility, setFormVisibility] = React.useState<any>(true)
  let defaultCountryCode = addressData?.country || Object.keys(PROJECT_COUNTRIES)[0]
  const [selectedCountryCode, setSelectedCountryCode] = React.useState(defaultCountryCode)

  const checkGeneratedAddressLabel = t("ecommerce.form-check-generated-address-label") || ""

  let showCountrySelect = (type === "shipping" && PROJECT_COUNTRY !== "PL")
  let showUseAsBlling = type === "shipping" && !props.dataEdit?.firstName
  let showInfoForBilling = type === "billing" || (useShippingAddressAsBilling && !props.dataEdit?.firstName)
  let _isAddressEdit = type === EAddressType.Shipping ? isAddressEdit.shipping : isAddressEdit.billing
  let isEdit = !!addressData.id

  /* Titolo */

  let title_key = ""
  if (type === "shipping" && !isEdit) title_key = "ecommerce.shippingAddress.new-shipping-address-title"
  if (type === "shipping" && isEdit) title_key = "ecommerce.shippingAddress.edit-shipping-address-title"

  if (type === "billing" && !isEdit) title_key = "ecommerce.billingAddress.new-billing-address-title"
  if (type === "billing" && isEdit) title_key = "ecommerce.billingAddress.edit-billing-address-title"
  let title = t(title_key)

  /* Validazione */
  let inputMaxLengthError = t("ecommerce.form-messagge.error-input-max-length").replace("[NUMBER]", inputMaxLength.toString())

  let requiredError = t("ecommerce.form-messagge.required")
  let numberError = t("ecommerce.form-messagge.number")

  let regExpPostalCode = /^([0-9]{5})$/
  let postalCodeError = t("ecommerce.form-messagge.invalid-postal-code")

  let regExpVat = /^([0-9]{11})$/
  let regExpFiscalCodeCompany = /^(?=.*[A-Z])[A-Z0-9]{9}$/
  let fiscalCodeCompanyError = t("ecommerce.form-messagge.invalid-fiscalCodeCompany")
  let vatError = t("ecommerce.form-messagge.invalid-vat")

  let regExpSDI = /(^[a-zA-Z0-9]{6,7}$|^$)/
  let SDIError = t("ecommerce.form-messagge.invalid-sdi")
  let regExpFiscalcode = /^([A-Za-z]{6}[0-9lmnpqrstuvLMNPQRSTUV]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9lmnpqrstuvLMNPQRSTUV]{2}[A-Za-z]{1}[0-9lmnpqrstuvLMNPQRSTUV]{3}[A-Za-z]{1})$/

  if (PROJECT_COUNTRY === "FR") {
    // Frannce SIRET  Validation
    regExpSDI = /(^[0-9]{14}$|^$)/
    SDIError = t("ecommerce.form-messagge.invalid-sdi")
    regExpVat = /^FR([0-9]{11})$/
  }

  if (PROJECT_COUNTRY === "BE") {
    regExpPostalCode = /^([0-9]{4})$/
    regExpVat = /^BE([0-9]{10})$/
  }

  if (PROJECT_COUNTRY === "ES") {
    regExpPostalCode = new RegExp(`^(${VALID_SPANISH_ZIP_PREFIXES.join('|')})\\d{3}$`);
    regExpFiscalcode = /^[a-zA-Z0-9]{6,12}$/
  }

  if (PROJECT_COUNTRY === "PL"){
    regExpVat = /^([0-9]{10})$/
    regExpFiscalcode = /^.{10}$/
  }

  if (PROJECT_COUNTRY === "NL") {
    regExpPostalCode = /^([0-9]{4})\s([A-Za-z]{2})$/
  }

  if (PROJECT_COUNTRY === "AT") {
    regExpPostalCode = /^([0-9]{4})$/
  }

  // lunghezze campi dipendenti da country
  let inputMaxLengthFirstName = inputMaxLength
  let inputMaxLengthLastName = inputMaxLength
  let inputMaxLengthPostalCode = inputMaxLength
  let inputMaxLengthPostalCodeError = inputMaxLengthError
  let inputMaxLengthCity = inputMaxLength
  let inputMaxLengthStreet = inputMaxLength
  let inputMaxLengthStreetNumber = inputMaxLength
  let inputMaxLengthFloorNumber = inputMaxLength
  let inputMaxLengthStair = inputMaxLength
  let inputMaxLengthCustomError = inputMaxLengthError
  let inputMaxLengthFiscalCode = inputMaxLength
  let inputMaxLenghFiscalCodeCompany = inputMaxLength
  let inputMaxLengthCompany = inputMaxLength
  let inputMaxLengthCompanyError = inputMaxLengthError
  let inputMaxLenghtFiscalCodeCompanyError = inputMaxLengthError
  let inputMaxLengthCityError = inputMaxLengthError
  let inputMaxLengthStreetError = inputMaxLengthError
  if (PROJECT_COUNTRY === "FR") {
    inputMaxLengthFirstName = 40
    inputMaxLengthLastName = 40
    inputMaxLengthCity = 35
    inputMaxLengthStreet = 35
    inputMaxLengthCityError = t("ecommerce.form-messagge.error-input-max-length").replace("[NUMBER]", inputMaxLengthCity.toString() )
    inputMaxLengthStreetError = t("ecommerce.form-messagge.error-input-max-length").replace("[NUMBER]", inputMaxLengthStreet.toString())
  }
  if (PROJECT_COUNTRY === "DE"){
    inputMaxLengthStreetNumber = 6
    inputMaxLengthFloorNumber = 6
    inputMaxLengthCustomError = t("ecommerce.form-messagge.error-input-max-length").replace("[NUMBER]", inputMaxLengthFloorNumber.toString())
  }

  if (PROJECT_COUNTRY === "ZA"){
    regExpPostalCode = /^([0-9]{4})$/
    regExpVat = /^([0-9]{10})$/
    inputMaxLengthPostalCode = 4
    inputMaxLengthStreetNumber = 6
    inputMaxLengthPostalCodeError = t("ecommerce.form-messagge.error-input-max-length").replace("[NUMBER]", inputMaxLengthPostalCode.toString())
    inputMaxLengthCustomError = t("ecommerce.form-messagge.error-input-max-length").replace("[NUMBER]", inputMaxLengthStreetNumber.toString())
  }

  if (PROJECT_COUNTRY === "PL") {
    regExpPostalCode = /^\d{2}-\d{3}$/
    inputMaxLengthCompany = 40
    inputMaxLengthCompanyError = t("ecommerce.form-messagge.error-input-max-length").replace("[NUMBER]", inputMaxLengthCompany.toString())
    inputMaxLenghFiscalCodeCompany = 10
    inputMaxLengthStreetNumber = 6
    inputMaxLenghtFiscalCodeCompanyError = t("ecommerce.form-messagge.error-input-max-length").replace("[NUMBER]", inputMaxLenghFiscalCodeCompany.toString())
    inputMaxLengthCustomError = t("ecommerce.form-messagge.error-input-max-length").replace("[NUMBER]", inputMaxLengthStreetNumber.toString())
  }

  if (PROJECT_COUNTRY === "PT") {
    regExpPostalCode = /^\d{4}-\d{3}$/
    inputMaxLenghFiscalCodeCompany = 9
    inputMaxLengthFiscalCode = 9
    regExpFiscalcode = /^\d{9}$/
    regExpFiscalCodeCompany = /^\d{9}$/
    inputMaxLengthStreetNumber = 6
    inputMaxLengthStreet = 35
    inputMaxLengthCompanyError = t("ecommerce.form-messagge.error-input-max-length").replace("[NUMBER]", inputMaxLengthFiscalCode.toString())
    inputMaxLenghtFiscalCodeCompanyError = t("ecommerce.form-messagge.error-input-max-length").replace("[NUMBER]", inputMaxLengthFiscalCode.toString())
    inputMaxLengthStreetError = t("ecommerce.form-messagge.error-input-max-length").replace("[NUMBER]", inputMaxLengthStreet.toString())
    inputMaxLengthCustomError = t("ecommerce.form-messagge.error-input-max-length").replace("[NUMBER]", inputMaxLengthStreetNumber.toString())
  }

  // eslint-disable-next-line no-useless-escape
  let regPhone = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{2,6}$/
  let phoneError = t("ecommerce.form-messagge.invalid-phone-number")

  let fiscalcodeError = t("ecommerce.form-messagge.invalid-fiscalcode")

  let pecOrSdiError = t("ecommerce.form-messagge.pec-sdi-required")
  let invalidEmail = t("ecommerce.form-messagge.email-invalid")

  let baseSchemaValidation = {
    firstName: yup.string().max(inputMaxLengthFirstName, inputMaxLengthError).required(requiredError),
    lastName: yup.string().max(inputMaxLengthLastName, inputMaxLengthError).required(requiredError),
    streetName: yup.string().max(inputMaxLengthStreet, inputMaxLengthStreetError).required(requiredError),
    streetNumber: yup.string().max(inputMaxLengthStreetNumber, inputMaxLengthCustomError).when({
      is: () => (["IT", "DE", "BE", "NL","ZA", "AT"].includes(PROJECT_COUNTRY)),
      then: yup.string().required(requiredError)
    }),
    postalCode: yup.string().max(inputMaxLengthPostalCode, inputMaxLengthPostalCodeError).required(requiredError).trim().matches(regExpPostalCode, postalCodeError),
    region: yup.string().when({
      is: () => (["IT", "DE", "FR", "BE", "NL", "PL", "ZA", "AT", "ES"].includes(PROJECT_COUNTRY)),
      then: yup.string().required(requiredError)
    }),
    city: yup.string().max(inputMaxLengthCity, inputMaxLengthCityError).required(requiredError),
    country: yup.string().max(inputMaxLength, inputMaxLengthError).when(
      {
        is: () => (type === "shipping" && PROJECT_COUNTRY !== "PL"),
        then: yup.string().required(requiredError)
      }

    ),
    mobile: yup.string().max(inputMaxLength, inputMaxLengthError).required(numberError).trim().matches(regPhone, phoneError),
    company: yup.string().max(inputMaxLengthCompany, inputMaxLengthCompanyError).when({
      is: () => (isCompany && (useShippingAddressAsBilling || type === "billing")),
      then: yup.string().required(requiredError)
    }),
    custom: yup.object().shape(
      {
        fields: yup.object().shape(
          {
            sdi: yup.string().max(inputMaxLength, inputMaxLengthError).when({
              is: () => (type === "shipping" && !["BE", "DE", "NL", "PL", "ZA", "AT", "ES", "PT"].includes(PROJECT_COUNTRY)),
              then: yup.string().trim().matches(regExpSDI, SDIError)
            }),
            vat: yup.string().max(inputMaxLength, inputMaxLengthError).when({
              is: () => (isCompany && !["DE", "NL", "PL", "ES", "PT"].includes(PROJECT_COUNTRY)),
              then: yup.string()
                  .required(requiredError)
                  .trim()
                  .test('vat-validation', vatError, async (value: any) => {
                    if (PROJECT_COUNTRY === 'AT' && value?.trim()) {
                      try {
                        const res = await ajaxMiddleware$(calls.Project.validateATVat(), undefined, { vat: value }).toPromise();
                        return res.isValid;
                      } catch (e) {
                        return false;
                      }
                    } else {
                      return regExpVat.test(value);
                    }
                  })
            }),
            pec: yup.string()
              .when('custom.fields.sdi', {
                is: (sdi: string) => (((sdi === "") || sdi === undefined) && (isCompany && !["BE", "DE", "NL", "PL", "ZA", "AT", "ES", "PT"].includes(PROJECT_COUNTRY))),
                then: yup.string().email(invalidEmail).required(pecOrSdiError)
              }
              ),
            fiscalcode: yup.string()
                .max(inputMaxLengthFiscalCode, inputMaxLenghtFiscalCodeCompanyError)
                .when({
                  is: () => (!isCompany && (useShippingAddressAsBilling || type === "billing") && (["IT", "PT", "ES"].includes(PROJECT_COUNTRY))),
                  then: yup.string().trim().when([], {
                    is: () => ["IT", "ES"].includes(PROJECT_COUNTRY),
                    then: yup.string().required(requiredError).matches(regExpFiscalcode, { message: fiscalcodeError, excludeEmptyString: true }),
                    otherwise: yup.string().matches(regExpFiscalcode, { message: fiscalcodeError, excludeEmptyString: true })
                  })
                }),
            fiscalcodeCompany: yup.string()
                .max(inputMaxLenghFiscalCodeCompany, inputMaxLenghtFiscalCodeCompanyError)
                .when({
                  is: () => isCompany && (((useShippingAddressAsBilling || type === "billing") && ["IT", "PL", "ES", "PT"].includes(PROJECT_COUNTRY))),
                  then: yup.string()
                      .required(requiredError)
                      .trim()
                      .when([], {
                        is: () => ["ES", "PT"].includes(PROJECT_COUNTRY),
                        then: yup.string().matches(regExpFiscalCodeCompany, fiscalCodeCompanyError),
                      })
                      .when([], {
                        is: () => PROJECT_COUNTRY === "PL",
                        then: yup
                          .string()
                          .min(inputMaxLenghFiscalCodeCompany, fiscalCodeCompanyError),
                      }),
                }),
            floorNumber: yup.string().max(inputMaxLengthFloorNumber, inputMaxLengthCustomError)
                .when({
                  is: () => (type === "shipping" && (["DE"].includes(PROJECT_COUNTRY))),
                  then: yup.string()
                }),
            stair: yup.string().max(inputMaxLengthStair, inputMaxLengthError)
                .when({
                  is: () => (["AT"].includes(PROJECT_COUNTRY)),
                  then: yup.string()
                }),
            hasElevator: yup.string().max(inputMaxLength, inputMaxLengthError).when(
                {
                  is: () => (type === "shipping" && ["DE"].includes(PROJECT_COUNTRY)),
                  then: yup.string()
                }

            ),
            suburb: yup.string().max(inputMaxLength, inputMaxLengthError).when(
                {
                  is: () => (type === "shipping" && ["ZA"].includes(PROJECT_COUNTRY)),
                  then: yup.string()
                }

            ),
          }
        )
      }
    ),
  }


  const schemaValitation = yup.object().shape(baseSchemaValidation)

  const {
    register,
    setValue,
    formState: { errors },
    trigger,
    getValues,
    reset,
    watch
  } = useForm({
    resolver: yupResolver(schemaValitation),
    defaultValues: {
      ...addressData,
      custom: {
        ...addressData.custom,
        fields: {
          ...addressData.custom?.fields,
          is_company: Boolean(addressData.custom?.fields?.is_company),
        },
      },
    },
    mode: "all",
    criteriaMode: "all",
    reValidateMode: "onChange",
  })

  const isCompany = !!watch("custom.fields.is_company");
  //console.log(watch())

  React.useImperativeHandle(ref, () => ({
    addAddressFormValidate: () => trigger(),
    addAddressFormGetData: getFormData,
    addAddressFormReset: () => reset()
  }))

  const getFormData = async () => {
    const data = getValues();
    data["country"] = selectedCountryCode
    let _hasElevator = false
    if(data.custom?.fields?.hasElevator === "YES"){
      _hasElevator = true
    }
    let addressData_: any = {
      country: selectedCountryCode,
      id: data["id"],
      firstName: data["firstName"],
      lastName: data["lastName"],
      streetName: data["streetName"],
      streetNumber: data["streetNumber"],
      additionalStreetInfo: data["additionalStreetInfo"],
      postalCode: data["postalCode"],
      city: data["city"],
      region: data["region"],
      mobile: data["mobile"].toString(),
      company: data["company"],
      custom: {
        type: {
          typeId: "type",
          key: "address-billing-info",
        },
        fields: {
          is_company: Boolean(data.custom?.fields?.is_company),
          vat: data.custom?.fields?.vat,
          pec: data.custom?.fields?.pec,
          sdi: data.custom?.fields?.sdi,
          fiscalcode: data.custom?.fields?.fiscalcode,
          fiscalcodeCompany: data.custom?.fields?.fiscalcodeCompany,
          floorNumber: data.custom?.fields?.floorNumber,
          stair: data.custom?.fields?.stair,
          suburb: data.custom?.fields?.suburb
        },
      },
    }

    if(data.custom?.fields?.hasElevator){
      addressData_.custom.fields["hasElevator"] = _hasElevator
    }

    if (isCompany === true) {
      delete addressData_.custom.fields.fiscalcode
    } else {
      delete addressData_.company
      delete addressData_.custom.fields.vat
      delete addressData_.custom.fields.pec
      delete addressData_.custom.fields.sdi
      delete addressData_.custom.fields.fiscalcodeCompany
    }

    return addressData_
  };

  React.useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    showInfoForBilling = type === "billing" || (useShippingAddressAsBilling && !props.dataEdit?.firstName)
  }, [useShippingAddressAsBilling])

  React.useEffect(() => {
    //se non ho accettato i cookie pubblicitari esplodo il form indirizzi (e disabilito google autocomplete)
    if(cookieConsent && cookieConsent.advertising === false){
      setState({
        styleAutocomplete: "",
        classAutomplete: "",
      })
    } else {
      if (!_isAddressEdit){
        setState({
          styleAutocomplete: (["PL"].includes(PROJECT_COUNTRY)) ? "" : "height-0",
          classAutomplete: "isAutocomplete",
        })
      }
    }
  }, [cookieConsent])

  let isAutocomplete = true
  let classHeight = ""
  let classAutomplete = ""

  if (isAutocomplete) {
    classHeight = (["PL"].includes(PROJECT_COUNTRY)) ? "" : "height-0"
    classAutomplete = "isAutocomplete"
  }

  if (_isAddressEdit) {
    classHeight = ""
    classAutomplete = ""
  }

  const [state, setState] = useState({
    styleAutocomplete: classHeight,
    classAutomplete: classAutomplete,
  })

  const handleChangeCountry = (country: any) => {
    if (country === "LU") {
      setValue("custom.fields.vat", "")
      setValue("company", "")
      setValue("custom.fields.is_company", false)
    }

    if (country) {
      setSelectedCountryCode(country);
      if (PROJECT_COUNTRIES[country]["regionsList"][PROJECT_LANGUAGE].length > 0) {
        setValue("region", "")
      } else {
        setValue("region", PROJECT_COUNTRIES[country]["name"][PROJECT_LANGUAGE]);
      }
    }


  }

  let toggleForm = () => {
    setState({
      styleAutocomplete: "",
      classAutomplete: classAutomplete,
    })
    setFormVisibility(false)
  }
  const onKeyDown = useKeyDownAsClick(toggleForm);

  const handleSelect = async (place: any) => {
    const address_components = place?.["addressComponents"] || []

    const extractFromAdress = (components: any, type: any) => {
      return (
        components
          .filter((component: any) => component.types.indexOf(type) === 0)
          .map((item: any) => item.shortText)
          .pop() || ""
      )
    }

    let postCode = extractFromAdress(address_components, "postal_code")
    let street = extractFromAdress(address_components, "route")
    let streetNum = extractFromAdress(address_components, "street_number")
    let additionalStreetInfo = extractFromAdress(address_components, "additional_street_info")
    let town = extractFromAdress(address_components, "locality")
    let country = extractFromAdress(address_components, "country")
    let city = extractFromAdress(address_components, "administrative_area_level_3")
    let region = extractFromAdress(address_components, "administrative_area_level_2")
    //let regionFr = region + "-" + postCode.slice(0, 2)
    let regionFr = "FR-" + postCode.slice(0, 2)
    if (town === "Monaco")
      regionFr = "MC-" + postCode.slice(0, 2)

    if (["FR", "NL"].includes(PROJECT_COUNTRY)) {
      setValue("additionalStreetInfo", additionalStreetInfo, { shouldValidate: true })
    }

    if (["FR"].includes(PROJECT_COUNTRY)) {
      setValue("streetName", street + "," + streetNum, { shouldValidate: true })
    } else {
      setValue("streetName", street, { shouldValidate: true })
      setValue("streetNumber", streetNum, { shouldValidate: true })
    }
    setValue("postalCode", postCode, { shouldValidate: true })
    setValue("city", city, { shouldValidate: true })
    // La germania NON ha le region
    if (!["DE", "PL", "PT"].includes(PROJECT_COUNTRY)) {
      setValue("region", region, { shouldValidate: true })
    }
    if (!["PL"].includes(PROJECT_COUNTRY)) {
      setValue("country", country, {shouldValidate: true})
    }
    setValue("city", town, { shouldValidate: true })
    if (PROJECT_COUNTRY === "FR") {
      setValue("region", regionFr, { shouldValidate: true })
    }

    setState({
      styleAutocomplete: "",
      classAutomplete: classAutomplete,
    })
  }

  React.useEffect(() => {
    if (state.styleAutocomplete === "") {
      setFormVisibility(false)
    } else {
      setFormVisibility(true)
    }
  }, [state])

  return (
    <StyledAddress>
      <form>
        <div className={`secondary row  ${state.classAutomplete}`} style={{ alignItems: "baseline" }}>
          <h2 className="new-shipping-address py-4 col-12">{title}</h2>
          <input type="hidden" {...register("id")} name="id" />
          <input type="hidden" {...register("type")} value={type} name="type" />

          <InputElement
            externalRegister={register("firstName")}
            className="col-sm-12"
            errors={errors.firstName?.message}
            label={t("ecommerce.formAddress.name")}
            id="firstNameEdit"
          />
          <InputElement
            externalRegister={register("lastName")}
            className="col-sm-12"
            errors={errors.lastName?.message}
            label={t("ecommerce.formAddress.lastname")}
            id="lastNameEdit"
          />
          {!_isAddressEdit && (
              <div className={`col-12 address-autocomplete ${formVisibility ? "d-block" : "d-none"}`}>
                <div
                    className="address-field-header"
                >
                  <label htmlFor="streetName">{t("ecommerce.formAddress.streetname")}</label>
                  <span
                      onClick={() => {
                        toggleForm()
                      }}
                      role="button"
                      tabIndex={0}
                      onKeyDown={onKeyDown}
                      style={{cursor: "pointer"}}
                  >
                  {t("ecommerce.formAddress.adressNotFound")}
                    <i className="fas fa-angle-down" style={{marginLeft: "5px", fontSize: "14px"}}/>
                  </span>
                </div>

              {cookieConsent && cookieConsent.advertising &&
                <AutocompleteAddress handleSelect={handleSelect} addressType={type} />
              }
            </div>
          )}

          {["IT", "DE", "BE", "NL", "PL", "FR", "ZA", "AT", "ES", "PT"].includes(PROJECT_COUNTRY) && (
              <>
                {checkGeneratedAddressLabel != null && checkGeneratedAddressLabel !== "" && PROJECT_COUNTRY === "NL" && (
                    <div
                        className={`col-sm-12  message--alert font-weight-bold my-2 ${formVisibility ? "d-none" : "d-block"}`}
                        dangerouslySetInnerHTML={{__html: checkGeneratedAddressLabel}}/>
                )}

                <InputElement
                    externalRegister={register("streetName")}
                    className={`col-sm-12 ${type === "shipping" && !isAddressEdit.shipping ? "mb-0" : ""} ${state.styleAutocomplete}`}
                    errors={errors.streetName?.message}
                    label={t("ecommerce.formAddress.streetname")}
                    placeholder={t("ecommerce.formAddress.streetname")}
                    id="streetName"
                />

                {type === "shipping" && !isAddressEdit.shipping && (
                  <div className="col-sm-12 extra-info mb-3">
                      {t("ecommerce.form-streetname-info")}
                  </div>
                )}

                {!["FR", "ES"].includes(PROJECT_COUNTRY) && (
                    <InputElement
                        externalRegister={register("streetNumber")}
                  className={`col-6 ${state.styleAutocomplete}`}
                  errors={errors.streetNumber?.message}
                  label={t("ecommerce.formAddress.streetnumber")}
                  id="streetNumber"
                />
              )}
              {["FR", "NL"].includes(PROJECT_COUNTRY) && (
                <InputElement
                  externalRegister={register("additionalStreetInfo")}
                  className={`col-6 col-lg-12  ${state.styleAutocomplete}`}
                  errors={errors.additionalStreetInfo?.message}
                  label={t("ecommerce.formAddress.additionalStreetInfo")}
                  id="additionalStreetInfo"
                />
              )}
              {PROJECT_COUNTRY === "AT" && type === "shipping" && (
                  <>
                    <InputElement
                        externalRegister={register("custom.fields.floorNumber")}
                        className={`col-sm-12 col-md-6 ${state.styleAutocomplete}`}
                        errors={errors.custom?.fields?.floorNumber?.message}
                        label={t("ecommerce.formAddress.floorNumber")}
                        placeholder={t("ecommerce.formAddress.floorNumber")}
                        id="custom.fields.floorNumber"
                    />
                  </>
              )}
              <InputElement
                externalRegister={register("postalCode")}
                className={`col-6 ${state.styleAutocomplete}`}
                errors={errors.postalCode?.message}
                label={t("ecommerce.formAddress.postalcode")}
                placeholder={t("ecommerce.formAddress.postalcode")}
                id="postalCode"
              />
            </>
          )}

          {PROJECT_COUNTRY === "ZA" && (
              <InputElement
                  externalRegister={register("custom.fields.suburb")}
                  className={`col-sm-12 col-md-6 ${state.styleAutocomplete}`}
                  errors={errors.custom?.fields?.suburb?.message}
                  label={t("ecommerce.formAddress.suburb")}
                  id="custom.fields.city"
              />
          )}

          <InputElement
            externalRegister={register("city")}
            className={`col-sm-12 col-md-6 ${state.styleAutocomplete}`}
            errors={errors.city?.message}
            label={t("ecommerce.formAddress.city")}
            id="city"
          />

          {["IT", "FR", "BE", "NL", "DE", "PL", "ZA", "ES", "AT"].includes(PROJECT_COUNTRY) && (

            (PROJECT_COUNTRIES[selectedCountryCode]["regionsList"][PROJECT_LANGUAGE].length > 0 &&
              <StyledInput className={`cmp_input col-sm-12 col-md-6 ${state.styleAutocomplete}`}>
                <label className="text-left">{t("ecommerce.formAddress.region")}</label>
                <select {...register("region")}>
                  <option value="">{t("ecommerce.formAddress.select")}</option>
                  {PROJECT_COUNTRIES[selectedCountryCode]["regionsList"][PROJECT_LANGUAGE].map((region: any, i: number) => {
                    let value = Object.keys(region)[0]
                    let text = String(Object.values(region)[0])
                    return (
                      <option key={i} value={value}>
                        {text}
                      </option>
                    )
                  })}
                </select>
                {errors.region?.message && <p className="message--alert small">{errors.region?.message}</p>}
              </StyledInput>
            )
            ||
            (
              PROJECT_COUNTRIES[selectedCountryCode]["regionsList"][PROJECT_LANGUAGE].length === 0 &&
              <>
                <input type="hidden" {...register("region")} defaultValue={PROJECT_COUNTRIES[selectedCountryCode]["name"][PROJECT_LANGUAGE]} value={PROJECT_COUNTRIES[selectedCountryCode]["name"][PROJECT_LANGUAGE]} />
              </>
            )

          )}

          {showCountrySelect && (
            <StyledInput className={`cmp_input col-sm-12 col-md-6 ${state.styleAutocomplete}`}>
              <label className="text-left">{t("ecommerce.formAddress.country")}</label>
              <select {...register("country")} name="country" onChange={(e) => handleChangeCountry(e.target.value)} value={selectedCountryCode} >
                <option key={1} defaultValue="" value="">
                  {t("ecommerce.formAddress.country")}
                </option>
                {Object.keys(PROJECT_COUNTRIES).map((country_key: any) => {
                  let current_country = PROJECT_COUNTRIES[country_key];
                  return (
                    <option key={2} value={country_key}>
                      {current_country["name"][PROJECT_LANGUAGE]}
                    </option>
                  )
                })}
              </select>
              {errors.country?.message && <p className="message--alert small">{errors.country?.message}</p>}
            </StyledInput>
          )}

          <InputElement
            externalRegister={register("mobile")}
            className={`col-sm-12 ${type === "shipping" && !isAddressEdit.shipping ? "mb-0" : ""} ${state.styleAutocomplete}`}
            errors={errors.mobile?.message}
            label={t("ecommerce.formAddress.phone")}
            type="tel"
            id="mobile"
          />

          {type === "shipping" && !isAddressEdit.shipping && (
            <div className={`col-sm-12 extra-info mb-3 ${state.styleAutocomplete}`}>
                {t("ecommerce.form-phone-info")}
            </div>
          )}

          {PROJECT_COUNTRY === "DE" && type === "shipping" && (
              <>
                <InputElement
                  externalRegister={register("custom.fields.floorNumber")}
                  className={`col-sm-12 col-md-6 ${state.styleAutocomplete}`}
                  errors={errors.custom?.fields?.floorNumber?.message}
                  label={t("ecommerce.formAddress.floorNumber")}
                  placeholder={t("ecommerce.formAddress.floorNumber")}
                  id="custom.fields.floorNumber"
                />
                <StyledInput className={`cmp_input col-sm-12 col-md-6 ${state.styleAutocomplete}`}>
                  <label className="text-left">{t("ecommerce.formAddress.hasElevator")}</label>
                  <select {...register("custom.fields.hasElevator")}>
                    <option value="" >{t("ecommerce.formAddress.hasElevatorSelect")}</option>
                    <option key={1} value={"YES"}>{"YES"}</option>
                    <option key={2} value={"NO"}>{"NO"}</option>
                  </select>
                  {errors.hasElevator?.message && <p className="message--alert small">{errors.hasElevator?.message}</p>}
                </StyledInput>
              </>
          )}

          {showUseAsBlling && !isFromMyAccount && (
            <>
              <div className="col-12" id="row_show_billing_info">
                <div className={`checkboxButton ${useShippingAddressAsBilling && ("split-line")} pb-3`}>
                  {console.log(useShippingAddressAsBilling)}
                  <input
                    type="checkbox"
                    checked={useShippingAddressAsBilling}
                    id="useAsBilling"
                    onChange={(event) => {
                      const checked = event.target.checked
                      setUseShippingAddressAsBilling(checked)
                      setValue("custom.fields.is_company", false, { shouldValidate: true })
                      if(numberAddressAvailable[type] < 1){
                        setAddAddressFormVisibility(EAddressType.Billing, !checked)
                      }
                    }}
                  />
                  {" "}
                  <label htmlFor="useAsBilling" className="text-left generic-label">
                    {t("ecommerce.formAddress.useAsBilling")}
                  </label>
                </div>
              </div>
            </>
          )}

          {showInfoForBilling && selectedCountryCode !== "LU" && (
            <div className="col-12" id="row_select_private_company">
              <div className="row">
                {["FR", "DE", "NL", "PL", "IT", "BE", "ZA", "AT", "ES", "PT"].includes(PROJECT_COUNTRY) && (
                  <>
                    <div className="col-12">
                      <div className="font-weight-bold pt-3">{t("ecommerce.formAddress.private_or_company")}</div> 
                      <div className="row">
                        <div className="col-6">
                          <div className="radio-item">
                            <input
                                type="radio"
                                id={`isPrivate-${type}`}
                                name={`personType-${type}`}
                                checked={!isCompany}
                                onChange={() => {
                                  setValue("custom.fields.is_company", false, {
                                    shouldValidate: true,
                                    shouldDirty: true,
                                  })
                                  if (PROJECT_COUNTRY === 'PL') {
                                    setSendInvoice(false)
                                    setInvoiceValue(false)
                                  }
                                }}
                            />
                            <label htmlFor={`isPrivate-${type}`}>{t("ecommerce.formAddress.private_title")}</label>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="radio-item">
                            <input
                                type="radio"
                                id={`isCompany-${type}`}
                                name={`personType-${type}`}
                                checked={!!isCompany}
                                onChange={() => {
                                  setValue("custom.fields.is_company", true, {
                                    shouldValidate: true,
                                    shouldDirty: true,
                                  })
                                  if (PROJECT_COUNTRY === 'PL') {
                                    setSendInvoice(true)
                                    setInvoiceValue(true)
                                  }
                                }}
                            />
                            <label htmlFor={`isCompany-${type}`}>{t("ecommerce.formAddress.company_title")}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
              )}

                {/* COMPANY */}
                {isCompany && (
                    <>
                      <InputElement
                          externalRegister={register("company")}
                          className="col-sm-12"
                          label={t("ecommerce.formAddress.company")}
                          id="company"
                          errors={errors.company?.message}
                      />
                      {!["DE", "NL", "PL", "ES", "PT"].includes(PROJECT_COUNTRY) && (
                          <>
                            <InputElement
                                externalRegister={register("custom.fields.vat")}
                                placeholder={t("ecommerce.form-message.vat-placeholder")}
                                className="col-sm-12"
                                label={t("ecommerce.formAddress.pIva")}
                                id="custom.fields.vat"
                                errors={errors.custom?.fields?.vat?.message}
                            />
                          </>
                      )}
                      {!["BE", "DE", "NL", "PL", "ZA", "AT", "ES", "PT"].includes(PROJECT_COUNTRY) && (
                      <>
                        <InputElement
                          externalRegister={register("custom.fields.pec")}
                          className="col-sm-12 col-md-6"
                          label={t("ecommerce.formAddress.pec")}
                          id="custom.fields.pec"
                          errors={errors.custom?.fields?.pec?.message}
                        />
                        <InputElement
                          externalRegister={register("custom.fields.sdi")}
                          placeholder={t("ecommerce.form-message.sdi-placeholder")}
                          className="col-sm-12 col-md-6"
                          label={t("ecommerce.formAddress.sdi")}
                          id="custom.fields.sdi"
                          errors={errors.custom?.fields?.sdi?.message}
                        />
                      </>
                    )}
                    {["IT", "PL", "ES", "PT"].includes(PROJECT_COUNTRY) && (
                      <>
                        <InputElement
                          externalRegister={register("custom.fields.fiscalcodeCompany")}
                          className="col-sm-12 col-md-6"
                          label={t("ecommerce.formAddress.fiscalcodeCompany")}
                          id="custom.fields.fiscalcodeCompany"
                          errors={errors.custom?.fields?.fiscalcodeCompany?.message}
                        />
                      </>
                    )}
                  </>
                )}
                {/* NOT COMPANY */}
                {!isCompany && ["IT", "PT", "ES"].includes(PROJECT_COUNTRY) && (
                  <>
                    <InputElement
                      externalRegister={register("custom.fields.fiscalcode")}
                      className="col-sm-12"
                      label={t("ecommerce.formAddress.fiscalcode")}
                      placeholder={t("ecommerce.formAddress.fiscalcode")}
                      hint={t("ecommerce.formAddress.fiscalcode.info")}
                      errors={errors.custom?.fields?.fiscalcode?.message}
                      id="custom.fields.fiscalcode"
                    />
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </form>
    </StyledAddress>
  )
})
